import React from "react";
import { ActorType, AuditLog } from "@common/types/auditLog";
import { RelativeTime } from "@design-system/RelativeTime/RelativeTime";
import { MessageSentBy } from "@common/types/chat";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { KickAvatar } from "@components/avatar/KickAvatar";
import classNames from "classnames";
import {
    ChatChangeComponent,
    defineChatChangeComponent,
} from "../helpers/defineChatChangeComponent";
import { AuditLogActor } from "../AuditLogActor";
import { useIsVisibleAgentActor } from "../hooks/useIsVisibleAgentActor";
import { getChatTaskAuditLogContent } from "./getChatTaskAuditLogContent";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
    actor: MessageSentBy | null;
}

export const ChatTaskAuditLog: React.FC<Props> = ({ log, actor }) => {
    const content = getChatTaskAuditLogContent(log);
    const changeComponent = defineChatChangeComponent(log);
    const isAgentActor = useIsVisibleAgentActor(log.actorType);
    const isUserActor =
        !isAgentActor &&
        (log.actorType === ActorType.USER || log.actorType === ActorType.AGENT);

    return (
        <div className={styles.chatTaskAuditLogItem}>
            {isUserActor && actor ? (
                <UserAvatar user={actor} size="sm" aria-hidden />
            ) : (
                <KickAvatar size="sm" aria-hidden />
            )}
            <main
                className={classNames({
                    [styles.chatTaskEntitiesAuditLogContent]:
                        changeComponent === ChatChangeComponent.ENTITIES,
                })}
            >
                <AuditLogActor
                    actorId={log.actorId}
                    actorName={log.actorName}
                    actorType={log.actorType}
                    log={log}
                />{" "}
                {content}
                <span className={styles.separator}>•</span>{" "}
                <RelativeTime date={log.createdAt} />
            </main>
        </div>
    );
};
